export const styles = ({ palette, breakpoints }) => ({
  fontStyleBig: {
    fontSize: 26,
  },
  fontStyleSmall: {
    fontSize: 20,
  },
});
